/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Tools_Browse_AllInputs */

const en_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Or browse every free tool.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Or browse " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "every free tool" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const zh_hans1_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`或浏览全部免费工具。`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "或浏览" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "全部免费工具" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "。" }])
			})
		}
	)
);

const pt_br2_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Ou veja todas as ferramentas grátis.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Ou veja " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "todas as ferramentas grátis" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const es_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`O explora todas las herramientas gratis.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "O explora " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "todas las herramientas gratis" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const fr_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Ou parcourez tous les outils gratuits.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Ou parcourez " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "tous les outils gratuits" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const de_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Oder stöbere in allen kostenlosen Tools.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Oder stöbere in " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "allen kostenlosen Tools" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const ru_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Или посмотрите все бесплатные инструменты.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Или посмотрите " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "все бесплатные инструменты" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const it_platform_tools_browse_all = /** @type {((inputs: Platform_Tools_Browse_AllInputs) => LocalizedString) & { parts: (inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Tools_Browse_AllInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Oppure sfoglia tutti gli strumenti gratuiti.`)
		}),
		{
			parts: /** @type {(inputs: Platform_Tools_Browse_AllInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Oppure sfoglia " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "tutti gli strumenti gratuiti" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Or browse every free tool." |
*
* @param {Platform_Tools_Browse_AllInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_tools_browse_all = /** @type {((inputs?: Platform_Tools_Browse_AllInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Platform_Tools_Browse_AllInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Platform_Tools_Browse_AllInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Platform_Tools_Browse_AllInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_platform_tools_browse_all(inputs)
			if (locale === "pt-BR") return pt_br2_platform_tools_browse_all(inputs)
			if (locale === "es") return es_platform_tools_browse_all(inputs)
			if (locale === "fr") return fr_platform_tools_browse_all(inputs)
			if (locale === "de") return de_platform_tools_browse_all(inputs)
			if (locale === "ru") return ru_platform_tools_browse_all(inputs)
			if (locale === "it") return it_platform_tools_browse_all(inputs)
			return en_platform_tools_browse_all(inputs)
		}),
		{
			parts: /** @type {(inputs?: Platform_Tools_Browse_AllInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_platform_tools_browse_all.parts === "function" ? zh_hans1_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: zh_hans1_platform_tools_browse_all(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_platform_tools_browse_all.parts === "function" ? pt_br2_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: pt_br2_platform_tools_browse_all(inputs) }]
				if (locale === "es") return typeof es_platform_tools_browse_all.parts === "function" ? es_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: es_platform_tools_browse_all(inputs) }]
				if (locale === "fr") return typeof fr_platform_tools_browse_all.parts === "function" ? fr_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: fr_platform_tools_browse_all(inputs) }]
				if (locale === "de") return typeof de_platform_tools_browse_all.parts === "function" ? de_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: de_platform_tools_browse_all(inputs) }]
				if (locale === "ru") return typeof ru_platform_tools_browse_all.parts === "function" ? ru_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: ru_platform_tools_browse_all(inputs) }]
				if (locale === "it") return typeof it_platform_tools_browse_all.parts === "function" ? it_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: it_platform_tools_browse_all(inputs) }]
				return typeof en_platform_tools_browse_all.parts === "function" ? en_platform_tools_browse_all.parts(inputs) : [{ type: "text", value: en_platform_tools_browse_all(inputs) }]
			})
		}
	)
);